export enum PolicyPanelEvents {
  PRE_SAVE = 'policyPanelPreSave',
  SAVE = 'policyPanelSave',
  CLONE = 'policyPanelClone',
  CANCEL = 'policyPanelCancel',
}
